const NrcMenu = (props: React.HTMLAttributes<SVGElement>): JSX.Element => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="36"
    height="24"
    viewBox="0 0 36 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 2C0 0.89543 0.89543 0 2 0H34C35.1046 0 36 0.89543 36 2C36 3.10457 35.1046 4 34 4H2C0.89543 4 0 3.10457 0 2ZM0 12C0 10.8954 0.89543 10 2 10H34C35.1046 10 36 10.8954 36 12C36 13.1046 35.1046 14 34 14H2C0.89543 14 0 13.1046 0 12ZM0 22C0 20.8954 0.89543 20 2 20H34C35.1046 20 36 20.8954 36 22C36 23.1046 35.1046 24 34 24H2C0.89543 24 0 23.1046 0 22Z"
      fill="#00355E"
    />
  </svg>
);
export default NrcMenu;
